import { useQuery as useRestQuery } from 'react-query';

export default useRestQuery;
